'use client';

import { useTranslations } from 'next-intl';
import { ChannelGithub } from '@/app/components/icons/ChannelGithub';
import { VIDU_SKILL_GITHUB_URL } from '@/app/constants';

export const NavGithubCard = () => {
  const t = useTranslations();

  return (
    <div className="px-2">
      <button
        type="button"
        className="flex h-16 w-full cursor-pointer items-center justify-start gap-3 rounded-12 border border-system-white08 light:border-transparent bg-[rgba(87,101,242,0.16)] px-4 py-2 hover:bg-[rgba(87,101,242,0.24)]"
        onClick={() => {
          window.open(VIDU_SKILL_GITHUB_URL, '_blank');
        }}
      >
        {/* 默认（dark）：外圈白、内 logo 默认深灰；light：外圈品牌紫、内 logo 反白。两套 SVG 切换比单图标颜色反转更直观，且不依赖 useTheme。 */}
        <ChannelGithub className="light:hidden size-6 shrink-0 text-system-white" />
        <ChannelGithub className="light:block hidden size-6 shrink-0 text-[#5765F2]" logoFill="#FFF" />
        <div className="flex flex-col items-start text-left">
          <span className="font-semibold light:text-system-text01 text-sm text-system-white leading-[1.2]">
            {t('claw.nav.viduSkillTitle')}
          </span>
          <span className="font-normal light:text-system-text04 text-system-white48 text-xs leading-[1.35]">
            {t('claw.nav.viduSkillSubtitle')}
          </span>
        </div>
      </button>
    </div>
  );
};
